import { useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreHotelSteps,
  HotelNavigationFlowProvider,
  NavigationFlow,
} from "@b2bportal/core-utilities";
import { useI18nContext } from "@hopper-b2b/i18n";
import defaultStyles from "./styles.module.scss";
import { ActionButton } from "@/components";
import { useHotelsFlow } from "@/pages/Hotels/hooks";
import { TripsPageContext } from "@/pages/Trips/components/MyTripsPage";

const BookAHotelButton = () => {
  const goToStep = NavigationFlow.useGoToStep();

  const { t } = useI18nContext();

  return (
    <ActionButton
      message={t("trips.myTripsPage.noResults.bookAHotel")}
      onClick={() => goToStep(CoreHotelSteps.SEARCH)}
    />
  );
};

type NoTripResultsProps = {
  pageContext?: TripsPageContext;
  hasError: boolean;
};

export const NoTripResults = ({
  pageContext,
  hasError,
}: NoTripResultsProps) => {
  const [block, cn] = useModuleBEM(defaultStyles, "NoTripResults");

  const { t } = useI18nContext();
  const perkspotHotelFlow = useHotelsFlow({
    CheckoutPage: () => null,
  });

  const ctaButton = !hasError ? (
    <HotelNavigationFlowProvider navigationFlow={perkspotHotelFlow}>
      <BookAHotelButton />
    </HotelNavigationFlowProvider>
  ) : (
    <ActionButton
      onClick={() => window.location.reload()}
      message={t("retry")}
    />
  );

  switch (pageContext) {
    case TripsPageContext.Completed:
      return (
        <div className={block}>
          <div className={cn("container")}>
            <h2 className={cn("title")}>
              {t("trips.myTripsPage.noResults.completed.title")}
            </h2>
            <div className={cn("subtitle")}>
              {t("trips.myTripsPage.noResults.completed.subtitle")}
            </div>
          </div>
        </div>
      );
    case TripsPageContext.Upcoming:
      return (
        <div className={block}>
          <div className={cn("container")}>
            <h2 className={cn("title")}>
              {t("trips.myTripsPage.noResults.title")}
            </h2>
            <div className={cn("subtitle")}>
              {t("trips.myTripsPage.noResults.subtitle")}
            </div>
            <div className={cn("cta")}>{ctaButton}</div>
          </div>
        </div>
      );
    case TripsPageContext.Guest:
    default:
      return (
        <div className={block}>
          <div className={cn("container")}>
            <h2 className={cn("title")}>
              {t("trips.myTripsPage.noResults.guest.title")}
            </h2>
            <div className={cn("subtitle")}>
              {t("trips.myTripsPage.noResults.guest.subtitleLine1")}
            </div>
            <div className={cn("subtitle")}>
              {t("trips.myTripsPage.noResults.guest.subtitleLine2")}
            </div>
            <div className={cn("cta")}>{ctaButton}</div>
          </div>
        </div>
      );
  }
};
